export default __webpack_public_path__ + "static/media/CMS_Auth Codes.81dac1dc.svg";